import type { TPaymentMethodIntegrations } from '../types/zustand/integrations';

export interface IIntegration {
  is_live: boolean;
  host: string | null;
  created_at: string;
  gateway_type: string;
  transaction_processed_callback: string;
  transaction_response_callback: string;
  is_deprecated: boolean;
  id: number;
  merchant_id: number;
  currency: string;
  is_auth: boolean;
  allowed_aggregators: string[];
  is_shopify: boolean;
  integration_type: string;
  settlement_type: string;
  is_standalone: boolean;
  integration_name: string;
  is_pos: boolean;
  installments: unknown | null;
  is_dcc: boolean;
  is_installments: boolean;
  is_google_pay: boolean;
  is_apple_pay: boolean;
}

export interface IIntegrationsApiResponse {
  data: {
    count: number;
    next: string | null;
    previous: string | null;
    results: IIntegration[];
  };
  validation: unknown | null;
  status: boolean;
  message: string;
}

export interface IIntegrationsAxiosResponse {
  data: IIntegrationsApiResponse;
}

export const mapIntegrationsToPaymentMethods = (
  integrationsData: IIntegrationsAxiosResponse
): TPaymentMethodIntegrations => {
  const result: TPaymentMethodIntegrations = {
    test: {},
    live: {},
  };

  if (integrationsData?.data?.data?.results) {
    const integrations = integrationsData.data.data.results;

    integrations.forEach((integration: IIntegration) => {
        if (!integration.gateway_type || !integration.id || !integration.currency) {
          return;
        }

        const mode = integration.is_live ? 'live' : 'test';
        const currency = integration.currency;
        const gatewayType = integration.gateway_type;

        // Initialize currency object if it doesn't exist
        if (!result[mode][currency]) {
          result[mode][currency] = {};
        }

        // Initialize gateway_type array if it doesn't exist
        if (!result[mode][currency][gatewayType]) {
          result[mode][currency][gatewayType] = [];
        }

        // Add integration if it doesn't already exist
        const existingIntegration = result[mode][currency][gatewayType].find(
          (item) => item.id === integration.id
        );

        if (!existingIntegration) {
          result[mode][currency][gatewayType].push({
            id: integration.id,
            gateway_type: integration.gateway_type,
            integration_name: integration.integration_name,
          });
        }
      }
    );

    // Sort integrations by ID within each gateway_type
    Object.keys(result.test).forEach((currency) => {
      Object.keys(result.test[currency]).forEach((gatewayType) => {
        result.test[currency][gatewayType].sort((a, b) => a.id - b.id);
      });
    });

    Object.keys(result.live).forEach((currency) => {
      Object.keys(result.live[currency]).forEach((gatewayType) => {
        result.live[currency][gatewayType].sort((a, b) => a.id - b.id);
      });
    });
  }

  return result;
};
